import React from "react";
import { COMPANY } from "../lib/contact";

const Impressum = () => (
  <div className="bg-[var(--na-bg)] pt-12 pb-24" data-testid="impressum-page">
    <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
      <p className="text-[11px] uppercase tracking-[0.3em] text-[var(--na-red)] font-semibold mb-3">Rechtliches</p>
      <h1 className="font-display text-4xl sm:text-5xl font-bold text-white tracking-tighter">Impressum</h1>

      <div className="prose prose-invert max-w-none mt-10 space-y-8 text-zinc-300">
        <Block title="Unternehmen">
          <p>{COMPANY.name}<br />{COMPANY.legal}<br />Inhaber: {COMPANY.owner}</p>
        </Block>
        <Block title="Anschrift">
          <p>{COMPANY.address}<br />{COMPANY.zipCity}<br />{COMPANY.country}</p>
        </Block>
        <Block title="Kontakt">
          <p>
            Telefon: <a href={`tel:${COMPANY.phoneTel}`} className="text-white hover:text-[var(--na-red)]">{COMPANY.phone}</a><br />
            E-Mail: <a href={`mailto:${COMPANY.email}`} className="text-white hover:text-[var(--na-red)]">{COMPANY.email}</a><br />
            Domain: {COMPANY.domain}
          </p>
        </Block>
        <Block title="UID-Nummer">
          <p>{COMPANY.vat}</p>
        </Block>
        <Block title="Unternehmensgegenstand">
          <p>Handel mit Kraftfahrzeugen (Fahrzeugverkauf, Fahrzeugankauf, auch beschädigter Fahrzeuge), Vermittlung von Finanzierungen.</p>
        </Block>
        <Block title="Aufsichtsbehörde / Gewerbebehörde">
          <p>Bezirkshauptmannschaft Korneuburg, Niederösterreich · Weitere Angaben werden vor Veröffentlichung ergänzt.</p>
        </Block>
        <Block title="Online-Streitbeilegung">
          <p>
            Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:
            <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer" className="ml-1 text-white hover:text-[var(--na-red)]">ec.europa.eu/consumers/odr</a>.
            Wir sind weder bereit noch verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
          </p>
        </Block>
        <Block title="Haftung für Inhalte">
          <p>Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen.</p>
        </Block>
        <p className="text-sm text-zinc-500 pt-6 border-t border-white/5">
          Weitere Angaben werden vor Veröffentlichung ergänzt.
        </p>
      </div>
    </div>
  </div>
);

const Block = ({ title, children }) => (
  <section>
    <h2 className="font-display text-xl font-semibold text-white mb-3 tracking-tight">{title}</h2>
    <div className="text-zinc-300 leading-relaxed">{children}</div>
  </section>
);

export default Impressum;
